import Vue from 'vue'
import FileExplorer from '../components/FileExplorer'

Vue.use(FileExplorer)